module.exports = __webpack_public_path__ + "assets/images/22c982feb8ec120344e6af4a737cbb7e-camera.png";